import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Signin from './views/Signin.vue'
import Signup from './views/Signup.vue'
import Role from './views/Role.vue'
import Browse from './views/Browse.vue'
import GetStudentInfo from './views/GetStudentInfo.vue'
import GetLabInfo from './views/GetLabInfo.vue'
import Position from './views/Position.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin

    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/browse',
      name: 'browse',
      component: Browse
    },
    {
      path: '/role',
      name: 'role',
      component: Role
    },
    {
      path: '/Position',
      name: 'Position',
      component: Position
    },
    {
      path: '/getstudentinfo',
      name: 'getstudentinfo',
      component: GetStudentInfo
    },
    {
      path: '/getlabinfo',
      name: 'getlabinfo',
      component: GetLabInfo
    }
  ]
})

/*
{
  path: '/signup',
  name: 'signup',
  component: Signup,
  beforeEnter: (to, from, next) => {
    if (store.getters.user) {
      next()
    } else {
      next('/signin')
    }
  }

}
*/
